import SectionHeader from '@/ui/molecules/SectionHeader';
import LessonCourseItem from '@/ui/organisms/LessonCourseItem';
import { getCourses } from '@/utils/lesson-course';

type Props = {
  onClick(): void;
  courseId: string;
};

const Component: React.FC<Props> = ({ courseId, onClick }) => {
  const course = getCourses().find(course => course.id === courseId);
  if (!course) {
    throw new Error('courseIdで特定されるCourseが見つからない');
  }

  return (
    <div className="rounded border border-gray-300 p-3">
      <SectionHeader
        caption={`${course.coach.coachName}監督のプレミアム会員限定動画を無料公開中！！`}
      />

      <LessonCourseItem
        id={course.id}
        onClick={onClick}
        title={course.title}
        imageUrl={course.imageUrl}
        description={course.description}
        buttonName={`${course.coach.coachName}監督の限定動画を今すぐ見る`}
      />
    </div>
  );
};

export default Component;
